import { useId } from "react"
import { useTranslation } from "react-i18next"
import { FormError } from "@/components/ui/form"
import { LabelAndSelectValue, Select, SelectContent, SelectItem, SelectTrigger } from "@/components/ui/select"
import { cn } from "@/lib/utils"
import { ReferralReason } from "@/types/__generated__/union-types"

interface ReasonSelectProps extends Omit<React.ComponentPropsWithoutRef<"select">, "onSelect"> {
  label: string
  onSelect?(value: string): void
  error?: string
  value: ReferralReason
  testId: string
  disabled?: boolean
  referralReasonsOptions: readonly ReferralReason[]
  triggerRef?: React.Ref<HTMLButtonElement>
}

export const ReasonSelect = ({ ...props }: ReasonSelectProps) => {
  const { label, onSelect, className, error, value, disabled, referralReasonsOptions: options, triggerRef } = props

  const { t } = useTranslation()
  const selectId = useId()

  return (
    <Select onValueChange={onSelect} disabled={disabled} value={value}>
      <div className={cn(className)} data-testid={props?.testId}>
        <SelectTrigger id={selectId} hasError={!!error} ref={triggerRef}>
          <LabelAndSelectValue label={label} value={t(`patient.referralReason.${value}`)} />
        </SelectTrigger>
        {error && <FormError>{error}</FormError>}
      </div>
      <SelectContent>
        {options.map((x) => {
          return (
            <SelectItem key={x} value={x} data-testid="reason-option">
              {t(`patient.referralReason.${x}`)}
            </SelectItem>
          )
        })}
      </SelectContent>
    </Select>
  )
}
